import React from 'react';
import Promise from 'bluebird';
import { ApolloProvider } from 'react-apollo';
import { Provider } from 'react-redux';

import { Provider as ActionsProvider } from './contexts/actions';
import { ThemeProvider as BaseThemeProvider } from './contexts/theme';
import apolloClient from './clients/apollo-client';
import { Provider as PaperThemeProvider } from './contexts/theme-paper';
import { SubscribeToPostponeSettings } from './modules/settings/actions';


Promise.config({
  cancellation: true,
});

const App = ({ children, store }: Object) => (
  <Provider store={store}>
    <BaseThemeProvider>
      <PaperThemeProvider>
        <ActionsProvider>
          <ApolloProvider client={apolloClient}>
            <SubscribeToPostponeSettings />
            { children }
          </ApolloProvider>
        </ActionsProvider>
      </PaperThemeProvider>
    </BaseThemeProvider>
  </Provider>
);

export default App;
